import { RequestWebApi, validateRequestErrorStatus } from "./Requests";

const controller = "Indicadores";

export const ObterIndicadorHome = () =>
  RequestWebApi.get(`/${controller}/ObterIndicadorHome`)
    .then(function (response) {
      const { resultData, success } = response.data;
      const indicadores = resultData;
      return { success, indicadores };
    })
    .catch(function (error) {
      validateRequestErrorStatus(error.response.status);
      const { success, message, errors } = error.response.data;
      return { success, message, errors, indicadores: [] };
    });
